<template>
  <div class="appointment-schedule-datearea">
    <div
      v-for="(item, index) in dateList"
      :key="item.date"
      :class="
        index === currentDate ? 'appointment-schedule-datearea-selected' : ''
      "
      @click="changeDate(index)"
      class="appointment-schedule-datearea-item"
    >
      <div>{{ item.week }}</div>
      <div>{{ item.date }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: 0,
      dateList: [],
      dayRange: 8
    };
  },
  created() {
    const list = [{ week: "全部", date: "排班" }];
    for (let index = 0; index < this.dayRange; index += 1) {
      const moment = this.$moment().add(index, "day");
      list.push({
        week: moment.format("ddd"),
        date: moment.format("MM.DD"),
        id: moment.format("YYYYMMDD")
      });
    }
    this.dateList = list;
    this.currentDate = 0;
  },
  methods: {
    changeDate(index) {
      this.currentDate = index;
      if (index === 0) {
        this.$emit("changeDate", {
          startDate: this.dateList[1].id,
          endDate: this.dateList[this.dayRange].id
        });
      } else {
        this.$emit("changeDate", {
          startDate: this.dateList[this.currentDate].id,
          endDate: this.dateList[this.currentDate].id
        });
      }
    }
  }
};
</script>

<style lang="less">
.appointment-schedule-datearea {
  display: flex;
  overflow-x: scroll;
  white-space: nowrap;

  &-item {
    width: 5rem;
    margin: 0.2rem;
    padding: 0.5rem;
    color: black;
    font-size: 0.85rem;
    text-align: center;
    background: white;
    border: 1px solid #c1bfb7;
    border-radius: 0.2rem;
  }

  &-selected {
    color: white;
    background: #6596f2;
  }
}
</style>
